/**优惠券模板**/
<template>
  <div class="couponMod" :class="status==1?'useCouponMod':''">
    <div class="top">
      <div class="left">
        <span class="content" v-if="couponType==='deduction'">
          <h2><span>￥</span>
            <span class="sum">{{sum.split('.')[0]}}</span><span>.{{sum.split('.')[1]}}</span></h2>
          <p>优惠券</p>
        </span>
        <span class="content" v-else="">
          <h2><span class="sum">{{(sum/10).toFixed(1)}}</span>折</h2>
          <p>打折券</p>
        </span>
        <div class="line"></div>
      </div>
      <div class="right" :class="backgroundFn">
        <div class="business">
          {{serviceType}}
        </div>
        <div class="content">
          <h2>{{title}}</h2>
          <p>有效时间
            <span>{{startTime}}</span>
            ~
            <span>{{endTime}}</span>
          </p>
        </div>
      </div>
    </div>
    <div class="bottom" v-if="useState===1">
      <span v-if="overdueTime!==''">{{overdueTime !== '永久有效' ? overdueTime : '永久'}}</span>
      {{overdueTime !== '永久有效' ? (overdueTime && overdueTime !== '' ? '后过期' : '已过期') : '有效'}}
    </div>
    <div class="bottom" v-else-if="useState===2">
      已使用
    </div>
    <div class="bottom" v-else-if="useState===3">
      已失效
    </div>
  </div>
</template>

<script>
  export default {
    name: 'xk-couponMod',
    props: ['type', 'overdueTime', 'endTime', 'startTime', 'title', 'sum', 'status', 'useState', 'couponType', 'serviceType'],
    computed: {
      backgroundFn: function () {
        let bac = ''
        switch (this.type) {
          case 'daijia':
            bac = 'daijia'
            break
          case 'zhuanche':
            bac = 'zhuanche'
            break
          case 'zhuanxian':
            bac = 'zhuanxian'
            break
          case 'paotui':
            bac = 'paotui'
            break
        }
        return bac
      }
    },
    data () {
      return {}
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/less" lang="less">
  .couponMod {
    height: 7.708333rem;
    width: 100%;
    background-size: 100%;
    margin: 1rem 0;
    overflow: hidden;
    .top {
      border-radius: 0.333rem 0.333rem 0 0;
      background-color: #fff;
      height: 5.833rem;
      overflow: hidden;
      .left {
        position: relative;
        width: 8.1666rem;
        height: 100%;
        float: left;
        .content {
          width: 100%;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          h2 {
            color: #f06553;
            text-align: center;
            span {
              font-size: 0.8333rem;
            }
            .sum {
              font-size: 2rem;
            }
          }
          P {
            text-align: center;
            color: #f06553;
            font-size: 0.8333rem;
          }
        }
        .line {
          height: 100%;
          width: 0.7rem;
          background: url(../../../../assets/img/coupon/yuan.png) repeat-y #f3f4f5;
          position: absolute;
          right: -0.7rem;
          top: 0;
        }
      }
      .right {
        float: left;
        width: calc(~'100% - 8.1666rem');
        height: 100%;
        box-sizing: border-box;
        position: relative;
        .business {
          position: absolute;
          left: 2.1rem;
          top: 25%;
          transform: translate(0, -50%);
          color: #999999;
        }
        .content {
          position: absolute;
          left: 2.1rem;
          top: 50%;
          transform: translate(0, -50%);
        }
        h2 {
          color: #333333;
          font-size: 1.166rem;
        }
        p {
          font-size: 0.8333rem;
          color: #999999;
          margin-top: 0.5rem;
        }
      }
      .daijia {
        background: url(../../../../assets/img/coupon/daijia.png) no-repeat 16.5rem center;
        background-size: 4.166rem;
      }
      .paotui {
        background: url(../../../../assets/img/coupon/paotui.png) no-repeat 16.5rem center;
        background-size: 4.166rem;
      }
      .zhuanche {
        background: url(../../../../assets/img/coupon/zhuanche.png) no-repeat 16.5rem center;
        background-size: 4.166rem;
      }
      .zhuanxian {
        background: url(../../../../assets/img/coupon/zhuanxian.png) no-repeat 16.5rem center;
        background-size: 4.166rem;
      }
    }
    .bottom {
      box-sizing: border-box;
      height: 2rem;
      line-height: 2rem;
      border-radius: 0 0 0.333rem 0.333rem;
      background-color: #fafafa;
      font-size: 0.8333rem;
      color: #e9b24a;
      padding-left: 1rem;
      span {
        color: #f06553;
      }
    }
  }

  .useCouponMod {
    color: #bbbbbb !important;
    .bottom {
      color: #bbbbbb !important;
    }
    h2, p, span {
      color: #bbbbbb !important;
    }
  }
</style>



// WEBPACK FOOTER //
// couponMod.vue?ada7b8ea